import { Github } from '@gonfalon/icons/Github';
import { Message } from '@gonfalon/messages/Message';

import { trackLoginForm } from '#utils/loginUtils';

import { OAuthButtonContainer } from '../OAuthButtonContainer';

import styles from './GitHubOAuthButton.module.css';

export const GitHubOAuthButton = () => {
  const href = 'oauth/github';
  return (
    <OAuthButtonContainer className={styles.container}>
      <a href={href} onClick={() => trackLoginForm('Github OAuth Button Clicked')}>
        <Github size="small" className={styles.icon} /> <Message id="login.oauthButtons.continueWithGithub" />
      </a>
    </OAuthButtonContainer>
  );
};
